<!-- ListInfo.vue -->
<script setup lang="ts">
  import { IListProps, INodeData } from '@/types/'
  import { ListCell } from '@components/index'

  const props = defineProps<IListProps>()
  const defaultIcon = 'arrow-right-square-fill'

  const onClick = props.onClick ?? (() => {})

  const handleClick = (rowData: INodeData) => {
    onClick(rowData)
  }
</script>

<template>
  <div class="container-fluid px-0">
    <div class="row">
      <div
        v-for="(rowData, rowIndex) in props.data"
        :key="rowIndex"
        class="col-12 mb-2"
      >
        <ListCell
          :id="rowData.id"
          :title="rowData.title"
          :icon="defaultIcon"
          @click="handleClick(rowData)"
        />
      </div>
    </div>
  </div>
</template>
